import React,{useEffect,useRef} from 'react';
import {ChevronDown,ListFilter} from 'lucide-react';
import {calendarSourceDefaults,calendarTeamSelected} from '../Calendar/calendarSources';

export default function OverviewCalendarPicker({names,selection,onChange}) {
  const root=useRef(null);
  useEffect(()=>{
    const outside=event=>{if(root.current&&!root.current.contains(event.target))root.current.open=false;};
    const escape=event=>{if(event.key==='Escape'&&root.current?.open){event.preventDefault();root.current.open=false;root.current.querySelector('summary')?.focus();}};
    document.addEventListener('pointerdown',outside);document.addEventListener('keydown',escape);
    return()=>{document.removeEventListener('pointerdown',outside);document.removeEventListener('keydown',escape);};
  },[]);
  const teams=Object.entries(names||{});
  const selected=[...(selection.personal?['Personal Calendar']:[]),...teams.filter(([id])=>calendarTeamSelected(selection,id)).map(([,name])=>name)];
  const label=selected.length===teams.length+1?'All calendars':selected.length===1?selected[0]:`${selected.length} calendars`;
  return <details className="overview-calendar-picker" ref={root}>
    <summary aria-label="Choose calendars for Upcoming Events"><ListFilter size={15}/><span>{label}</span><ChevronDown size={14}/></summary>
    <div className="overview-calendar-picker__panel">
      <fieldset><legend>Calendars to show</legend>
        <label><input type="checkbox" checked={selection.personal} onChange={event=>onChange({...selection,personal:event.target.checked})}/>Personal Calendar</label>
        {teams.map(([id,name])=><label key={id}><input type="checkbox" checked={calendarTeamSelected(selection,id)} onChange={event=>onChange({...selection,teams:{...selection.teams,[id]:event.target.checked}})}/>{name}</label>)}
      </fieldset>
      <div className="overview-calendar-picker__actions"><button type="button" onClick={()=>onChange(calendarSourceDefaults('all'))}>Select all calendars</button><button type="button" onClick={()=>onChange({personal:false,defaultTeams:false,teams:{}})}>Clear</button></div>
    </div>
  </details>;
}
